import { gql } from '@apollo/client';

export default gql`
  mutation processTierBenefitUpgrade($bookingReference: String!, $currency: Currency!, $customerId: String!, $itemRefs: [String!]!) {
    processTierBenefitUpgrade(bookingReference: $bookingReference, currency: $currency, customerId: $customerId, itemRefs: $itemRefs) {
      success
    }
  }
`;
